
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stod2sport",
      function () {
        return require("private-next-pages/stod2sport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stod2sport"])
      });
    }
  